import SendAnalyticsDisplay from './SendAnalyticsEventDisplay'
import SendAnalyticsForm from './SendAnalyticsEventForm.container'
import IconSegment from 'components/Icons/Segment'

export default {
  id: 'send_segment_event',
  label: 'Send Analytics Event',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/send-analytics-event',
  icon: IconSegment,
  inputs: [{}],
  outputs: [{}],
  display: SendAnalyticsDisplay,
  form: SendAnalyticsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendAnalyticsEvent/index.js